/* eslint-disable react/jsx-one-expression-per-line */
import { ReactElement, useState, useEffect, useContext } from 'react';
import { tile } from '@interfaces/interfaces';
import { Field, useFormikContext, getIn } from 'formik';
import { TileRadio, Alert, CheckboxInput, CheckboxInputGroup } from '@components';
import gridStyles from '@pages/forms/Grid.module.scss';
import { iFVSFormValues } from '@services/FVSService';
import classnames from 'classnames';
// import FVSStep3AlertContent1 from '@components/Content/AlertContent/FVSStep3AlertContent1';
// import FVSStep3AlertContent2 from '@components/Content/AlertContent/FVSStep3AlertContent2';
import FVSStep3AlertContent3 from '@components/Content/AlertContent/FVSStep3AlertContent3';
import FVSStep3AlertContent4 from '@components/Content/AlertContent/FVSStep3AlertContent4';
// import FVSStep3AlertContent5 from '@components/Content/AlertContent/FVSStep3AlertContent5';
import VicFinesContext from '@pages/forms/VicFinesFormContext';
import styles from './FVSStep3.module.scss';
import InfoIcon from '../../../../images/info.svg';

function FVSStep3(): ReactElement {
  const { tooltips } = useContext(VicFinesContext);
  const additionalText1Title = Object.keys(tooltips).filter((v) => v.includes('step3additionaltext1'));
  const step3Additionaltext1content = tooltips[additionalText1Title[0]];
  const titleText1 = additionalText1Title[0].substring(additionalText1Title[0].indexOf('|'), additionalText1Title[0].length).replaceAll('|', ' ');
  const additionalText2Title = Object.keys(tooltips).filter((v) => v.includes('step3additionaltext2'));
  const step3Additionaltext2content = tooltips[additionalText2Title[0]];
  const titleText2 = additionalText2Title[0].substring(additionalText2Title[0].indexOf('|'), additionalText2Title[0].length).replaceAll('|', ' ');
  const additionalText3Title = Object.keys(tooltips).filter((v) => v.includes('step3additionaltext3'));
  const step3Additionaltext3content = tooltips[additionalText3Title[0]];
  const titleText3 = additionalText3Title[0].substring(additionalText3Title[0].indexOf('|'), additionalText3Title[0].length).replaceAll('|', ' ');

  const step3AdditionalText1 = (): ReactElement => (
    // eslint-disable-next-line react/no-danger
    <div className={styles.accordContent} dangerouslySetInnerHTML={{ __html: step3Additionaltext1content }} />
  );
  const step3AdditionalText2 = (): ReactElement => (
    // eslint-disable-next-line react/no-danger
    <div className={styles.accordContent} dangerouslySetInnerHTML={{ __html: step3Additionaltext2content }} />
  );
  const step3AdditionalText3 = (): ReactElement => (
    // eslint-disable-next-line react/no-danger
    <div className={styles.accordContent} dangerouslySetInnerHTML={{ __html: step3Additionaltext3content }} />
  );
  const YesValue = (): ReactElement => (
    <>
      <div>Yes</div>
    </>
  );

  const NoValue = (): ReactElement => (
    <>
      <div>No</div>
    </>
  );

  const TILE_DATA: tile[] = [
    {
      body: <YesValue />,
      value: 'true',
    },
    {
      body: <NoValue />,
      value: 'false',
    },
  ];

  const SevenDayNoticeContent = (): ReactElement => (
    <>
      <p>A sheriff's officer served you with a {' '}
        <a href="https://online.fines.vic.gov.au/Infringement-fines/7-Day-Notice" target="_blank" rel="noreferrer">
          7 Day Notice
        </a> (link opens in a new window)
      </p>
    </>
  );

  const TILE_DATA_FINES_ACTIONS: tile[] = [
    {
      body: <SevenDayNoticeContent />,
      value: 'Has7DayNotice',
    },
    {
      body: "A sheriff's officer has removed your numberplates",
      value: 'NumberPlatesRemoved',
    },
    {
      body: "A sheriff's officer has wheel clamped your vehicle",
      value: 'WheelClamped',
    },
    {
      body: 'You have lost your licence (either due to licence sanctions or as a result of demerit points)',
      value: 'LicenceLost',
    },
    {
      body: 'The Director, Fines Victoria has made an attachment of earnings or debt direction',
      value: 'MadeAttachment',
    },
    {
      body: 'The Director, Fines Victoria has recorded a charge over land that you own',
      value: 'RecordedCharge',
    },
    {
      body: "A sheriff's officer has seized your vehicle",
      value: 'VehicleSeized',
    },
  ];
  const { values, touched }: { values: iFVSFormValues; touched: any } = useFormikContext();
  const formikContext = useFormikContext();
  const { ActionsTakenOnFine, NoActionsTaken, HasLinkBwFVSAndFines, HasEvidenceToSupport } = values;
  const hasTouchedActionsTaken = getIn(touched, 'ActionsTakenOnFine');
  const hasTouchedNoActionTaken = getIn(touched, 'NoActionsTaken');
  const [isActionGpDisabled, setActionGpDisabled] = useState(false);
  const [isNoneOptDisabled, setNoneOptDisabled] = useState(false);
  const urgentOptions = ['WheelClamped', 'NumberPlatesRemoved', 'LicenceLost', 'Has7DayNotice'];
  useEffect(() => {
    if (NoActionsTaken) {
      setActionGpDisabled(true);
      if (!ActionsTakenOnFine.includes('None') && ActionsTakenOnFine.length === 0) {
        getIn(values, 'ActionsTakenOnFine').push('None');
      }
      const urgent = values.ActionsTakenOnFine.some((ele) => urgentOptions.includes(ele));
      formikContext.setFieldValue('isUrgent', urgent);
    } else if (ActionsTakenOnFine.length !== 0 && !ActionsTakenOnFine.includes('None')) {
      const urgent = values.ActionsTakenOnFine.some((ele) => urgentOptions.includes(ele));
      formikContext.setFieldValue('isUrgent', urgent);
      setNoneOptDisabled(true);
    } else if (ActionsTakenOnFine.length !== 0 && ActionsTakenOnFine.includes('None')) {
      formikContext.setFieldValue(
        'ActionsTakenOnFine',
        getIn(values, 'ActionsTakenOnFine').filter((action: string) => action !== 'None'),
      );
    } else {
      setActionGpDisabled(false);
      setNoneOptDisabled(false);
    }
  }, [ActionsTakenOnFine, NoActionsTaken]);

  return (
    <div className={gridStyles.form}>
      <span className="vfH2">Before you continue</span>
      <span className="subHeadingH3">If you have any questions or concerns while completing this form, please call us on 1300 019 983 and our staff will be able to help and support you.
        <br />
        <br />
        Answering these questions will help us determine the eligibility and urgency of your application.
      </span>
      <div
        className={classnames({
          [gridStyles.gridColFull]: true,
          [styles.inputGroupSpacing]: true,
        })}>
        <div className={styles.col}>
          <div
            className={classnames({
              [styles.bold]: true,
              [styles.checkBoxTitleSpacing]: true,
              [styles.inputError]:
                (hasTouchedActionsTaken || hasTouchedNoActionTaken) && !NoActionsTaken && ActionsTakenOnFine.length === 0,
            })}>
            Has any action been taken for this fine? (select any statements that apply)
          </div>
          <Field name="ActionsTakenOnFine" component={CheckboxInputGroup} tileData={TILE_DATA_FINES_ACTIONS} disabled={isActionGpDisabled} displayError={false} />
          <div className={styles.separator}>OR</div>
          <Field name="NoActionsTaken" component={CheckboxInput} title="None of these apply" disabled={isNoneOptDisabled} displayError={false} hrRequired />
          {(hasTouchedActionsTaken || hasTouchedNoActionTaken) && !NoActionsTaken && ActionsTakenOnFine.length === 0 && (
            <div className={styles.inputError}>Please select an option</div>
          )}
          {((!ActionsTakenOnFine.includes('MadeAttachment') && !ActionsTakenOnFine.includes('RecordedCharge') && !ActionsTakenOnFine.includes('VehicleSeized')) && ActionsTakenOnFine.includes('Has7DayNotice')) && (
            <Alert title={titleText1} theme="info" message={step3AdditionalText1()} icon={InfoIcon} />
          )}
          {((ActionsTakenOnFine.includes('MadeAttachment') || ActionsTakenOnFine.includes('RecordedCharge') || ActionsTakenOnFine.includes('VehicleSeized')) && !ActionsTakenOnFine.includes('Has7DayNotice')) && (
            <Alert title={titleText2} theme="info" message={step3AdditionalText2()} icon={InfoIcon} />
          )}
          {((ActionsTakenOnFine.includes('MadeAttachment') || ActionsTakenOnFine.includes('RecordedCharge') || ActionsTakenOnFine.includes('VehicleSeized')) && ActionsTakenOnFine.includes('Has7DayNotice')) && (
            <Alert title={titleText3} theme="info" message={step3AdditionalText3()} icon={InfoIcon} />
          )}
        </div>
      </div>
      <div className={gridStyles.gridColFull}>
        <div className={styles.col}>
          <Field
            name="HasLinkBwFVSAndFines"
            title="Is there a link between the experience of family violence and the offending conduct or being unable to nominate the responsible driver?"
            component={TileRadio}
            tileData={TILE_DATA}
            orientationRow
            isMandatory
          />
          {HasLinkBwFVSAndFines === 'false' && (
            <Alert
              message={<FVSStep3AlertContent3 />}
              theme="info"
              title="To be eligible for the Family Violence Scheme, you must show a link between the family violence and the fines"
              icon={InfoIcon}
            />
          )}
        </div>
      </div>
      <div className={gridStyles.gridColFull}>
        <div className={styles.col}>
          <Field name="HasEvidenceToSupport" title="Do you have evidence to support the application?" component={TileRadio} tileData={TILE_DATA} orientationRow isMandatory />
          {HasEvidenceToSupport === 'false' && (
            <Alert message={<FVSStep3AlertContent4 />} theme="info" title="Without supporting documents, your application may not be successful" icon={InfoIcon} />
          )}
        </div>
      </div>
    </div>
  );
}

export default FVSStep3;
